export class WarningsModel {
    item_no: number;
    item_warnings: string

    constructor() {
        
    }
}